import { render, staticRenderFns } from "./PageLoadingView.vue?vue&type=template&id=cbc5a4ec&"
import script from "./PageLoadingView.vue?vue&type=script&lang=js&"
export * from "./PageLoadingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports